'use strict';

var index = require('../define-properties/index.js');
var polyfill = require('./polyfill.js');

var define = index;
var getPolyfill = polyfill;

var shim = function shimArrayPrototypeFind() {
	var polyfill = getPolyfill();

	define(Array.prototype, { find: polyfill }, {
		find: function () {
			return Array.prototype.find !== polyfill;
		}
	});

	return polyfill;
};

module.exports = shim;
